/* Little Hours — theme.js */
(function () {
  'use strict';

  /* Header: solid on scroll, mobile menu */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 24);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var toggle = header.querySelector('[data-menu-toggle]');
    var nav = document.getElementById('MobileNav');
    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        nav.hidden = open;
        header.classList.toggle('is-open', !open);
      });
    }
  }

  /* Product: variant selection without page reload */
  function initProduct(root) {
    var dataEl = root.querySelector('[data-product-json]');
    var form = root.querySelector('[data-product-form]');
    if (!dataEl || !form) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add-button]');
    var addLabel = form.querySelector('[data-add-label]');
    var priceWrap = root.querySelector('[data-price-wrap]');
    var fieldsets = Array.prototype.slice.call(form.querySelectorAll('[data-option-index]'));
    if (!fieldsets.length) return;

    function selectedOptions() {
      return fieldsets.map(function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(options) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i];
        var match = v.options.every(function (o, idx) { return o === options[idx]; });
        if (match) return v;
      }
      return null;
    }

    function markAvailability(options) {
      fieldsets.forEach(function (fs, idx) {
        fs.querySelectorAll('input[data-option-input]').forEach(function (input) {
          var test = options.slice();
          test[idx] = input.value;
          var v = findVariant(test);
          input.closest('.pill').classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }

    function update() {
      var options = selectedOptions();
      fieldsets.forEach(function (fs, idx) {
        var label = fs.querySelector('[data-option-value]');
        if (label) label.textContent = options[idx] || '';
      });

      var variant = findVariant(options);
      markAvailability(options);

      if (!variant) {
        addBtn.disabled = true;
        addLabel.textContent = data.strings.unavailable;
        return;
      }

      idInput.value = variant.id;
      addBtn.disabled = !variant.available;
      addLabel.textContent = variant.available ? data.strings.add : data.strings.soldOut;

      if (priceWrap) {
        var current = priceWrap.querySelector('[data-price]');
        if (current) current.textContent = variant.price;
        var compare = priceWrap.querySelector('[data-compare-price]');
        if (compare) {
          compare.textContent = variant.compare || '';
          compare.hidden = !variant.compare;
        }
      }

      if (variant.media) {
        var media = root.querySelector('[data-media-id="' + variant.media + '"]');
        var gallery = root.querySelector('[data-gallery]');
        if (media && gallery) {
          if (window.matchMedia('(max-width: 989px)').matches) {
            gallery.scrollTo({ left: media.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
          } else if (gallery.firstElementChild !== media) {
            gallery.insertBefore(media, gallery.firstElementChild);
            gallery.querySelectorAll('.product__media--lead').forEach(function (el) { el.classList.remove('product__media--lead'); });
            media.classList.add('product__media--lead');
          }
        }
      }

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-input]')) update();
    });
    markAvailability(selectedOptions());
    if (/[?&]variant=/.test(window.location.search)) { update(); var lhV = findVariant(selectedOptions()); var lhG = root.querySelector('[data-gallery]'); var lhM = lhV && lhV.media ? root.querySelector('[data-media-id="' + lhV.media + '"]') : null; if (lhG && lhM && window.matchMedia('(max-width: 989px)').matches) lhG.scrollTo({ left: lhM.offsetLeft - lhG.firstElementChild.offsetLeft, behavior: 'instant' }); }
  }

  /* Gentle reveal on scroll */
  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    var targets = document.querySelectorAll('.section__head, .statement__inner, .split__text, .split__media, .colorway, .detail, .featured .card');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    targets.forEach(function (el, i) {
      el.classList.add('reveal');
      el.style.transitionDelay = (i % 4) * 90 + 'ms';
      io.observe(el);
    });
  }

  function init() {
    initHeader();
    document.querySelectorAll('[data-product]').forEach(initProduct);
    if (!window.Shopify || !window.Shopify.designMode) initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
